import cls from 'classnames';
import { useCallback } from 'react';
import Link from 'next/link';

import Radio from '../form/Radio';

import { IPillsMenu, IPills } from './types';
import useStyles from './styles';

function PillsButtons({
  onSelectItem,
  pills,
  icons,
  selected,
  withLink,
  radioClassName,
  orientation = 'column',
}: IPillsMenu) {
  const classes = useStyles({ orientation });

  const onItemClick = useCallback(
    (pill: IPills, current: string) => {
      onSelectItem(pill.value, pill.text, current);
    },
    [onSelectItem],
  );

  return (
    <ul className={classes.list}>
      {pills.map((pill: IPills) => {
        const isSelected = pill.value === selected;
        const onSelect = isSelected ? undefined : () => onItemClick(pill, selected);

        const el = (
          <li key={pill.value}>
            <Radio
              className={radioClassName}
              value={pill.value}
              selected={isSelected}
              onSelect={onSelect}
            >
              <div className={classes.item}>
                {icons && icons[pill.iconName]}
                <span className={classes.iconText}>{pill.text}</span>
              </div>
            </Radio>
          </li>
        );
        if (withLink) {
          const href = pill.value === 'index' ? '/' : `/${pill.value}/`;

          return (
            <Link href={href} passHref key={pill.value}>
              <a className={cls(classes.link, { isSelected })}>{el}</a>
            </Link>
          );
        }

        return el;
      })}
    </ul>
  );
}

export default PillsButtons;
